export default __webpack_public_path__ + "static/media/sivanLogo.afbb28da.png";